import { O2OCommonContainer } from '../../../common/container/O2OContainer';
import { IState } from '../../../redux/reducer';
import LoginActivityComponentV2 from './LoginActivityComponentV2';

function mapStateToProps(rootState: IState) {
  return {};
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

export const LoginActivityContainer = O2OCommonContainer(LoginActivityComponentV2, mapStateToProps, mapDispatchToProps);
